import React, { Component } from 'react';
export default class LccSlotRender extends Component {
    static displayName = 'LccSlotRender';
    static defaultProps = {
        content: null,
    };
    render() {
        const { content, className, style } = this.props;
        return React.createElement("div", { className: className, style: style }, content);
    }
}
